var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-wrapper"},[_c('iframe',{ref:"jfsc",attrs:{"id":"jfsc","src":"https://account.haoyouzhushou.com/html/index.html?from=mydjClient","width":"100%","height":"716px","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }